export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = [
  "en",
  "es",
  "fr",
  "it",
  "de",
  "zh",
  "ko",
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export { ALL_NAMESPACES, NAMESPACES } from "./namespaces";
export {
  applyTenantTranslations,
  removeTenantTranslations,
  validateTenantTranslations,
} from "./tenant-loader";
export type { NamespaceKey } from "./namespaces";
